import { Component, EventEmitter, Output } from '@angular/core';
import { AppConfig } from '../../../app/app.config';

@Component({
  selector: 'daily-log-empty-state-component',
  templateUrl: 'daily-log-empty-state-component.html'
})
export class DailyLogEmptyStateComponent {
  @Output() goToActiveLogDayClicked: EventEmitter<any> = new EventEmitter();

  config = AppConfig.settings;

  constructor() {
  }

  ngOnInit() {

  }

  goToCurrentDayClicked() {
    this.goToActiveLogDayClicked.emit();
  }

}



// WEBPACK FOOTER //
// ./src/pages/daily-log/daily-log-empty-state-component/daily-log-empty-state-component.ts